import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import InsuredValue, {
  makeEmptyInsuredValues,
} from 'src/models/responseTypes/InsuredValue';
import CarItem, { makeEmpty } from '../../../models/helperTypes/CarItem';

export type CarState = {
  currentCar: CarItem;
  insuredValues: InsuredValue;
  hasInsuredRange: boolean;
};

const initialState: CarState = {
  currentCar: makeEmpty(),
  insuredValues: makeEmptyInsuredValues(),
  hasInsuredRange: false,
};

const carSlice = createSlice({
  name: 'car',
  initialState,
  reducers: {
    setCurrentCarGeneralData: (state, action: PayloadAction<CarItem>): void => {
      state.currentCar = action.payload;
    },
    updateInsuredValues: (state, action: PayloadAction<InsuredValue>): void => {
      state.insuredValues = action.payload;
    },
    updateHasInsuredRange: (state, action: PayloadAction<boolean>): void => {
      state.hasInsuredRange = action.payload;
    },
  },
});

export const {
  setCurrentCarGeneralData,
  updateInsuredValues,
  updateHasInsuredRange,
} = carSlice.actions;

export default carSlice.reducer;
